import { render, staticRenderFns } from "./BindArea.vue?vue&type=template&id=5f420f10&"
import script from "./BindArea.vue?vue&type=script&lang=js&"
export * from "./BindArea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports